import React from 'react';
import { Container, Stack } from '@mui/material';
import app_crash from 'assets/error_page.jpeg';
import { logoutUser } from 'redux/slices/user/userSlice';
import CustomButton from 'components/Common/Button';
import { withRouter, WithRouterProps } from './withRouter';
import AssistanceFooter from 'components/Common/AssistanceFooter';

export interface ErrorBoundaryProps extends WithRouterProps {
    children?: React.ReactNode;
}

interface ErrorBoundaryState {
    error: Error | null;
    loading: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    state = { error: null, loading: false };

    static getDerivedStateFromError(error: Error) {
        return { error };
    }
    componentDidCatch(error: Error) {
        console.log('$$$ ~ componentDidCatch ~ error:', error);
        // We can also log error messages to an error reporting service here
    }

    handleLogoutClick = async () => {
        const { dispatch } = this.props;
        this.setState({ loading: true });
        await dispatch(logoutUser());
        this.setState({ error: null, loading: false });
    };

    goToHome = () => {
        const { navigate } = this.props;
        this.setState({ error: null });
        navigate('/');
    };

    render() {
        if (this.state.error) {
            return (
                <Container>
                    <Stack alignItems="center">
                        <Stack justifyContent="center" alignItems="center" sx={{ maxWidth: 700, maxHeight: 700 }}>
                            <img src={app_crash} alt="App Crash" width="100%" height="100%" />
                        </Stack>
                        <Stack direction="row" gap={4}>
                            <CustomButton title="Go to home" onClick={this.goToHome} width={140} />
                            <CustomButton loading={this.state.loading} title="Logout" onClick={this.handleLogoutClick} width={140} />
                        </Stack>
                    </Stack>
                    <AssistanceFooter />
                </Container>
            );
        }
        return this.props.children;
    }
}

export default withRouter(ErrorBoundary);
